import React, { useEffect, useState } from "react";
import UserWrapper from "./ServiceLocation.style";
import PageTitle from "components/common/PageTitle";
import { connect } from "react-redux";
import ServiceLocationServices from "../../api/ServiceLocationServices";
import ServiceLocationForm from "../../components/serviceLocation/serviceLocationForm";
import EncryptDecrypt from "../../api/EncryptDecrypt";

const ServiceLocationEdit = props => {
  const [editedData, setEditedData] = useState(undefined);
  const hasParam = props.match.params.id;

  useEffect(() => {
    if (hasParam) {
      const params = {
        id: hasParam
      };
      ServiceLocationServices.view(params)
        .then(res => {
          let data = EncryptDecrypt.decrypt(res.data);
          setEditedData(data.data);
        })
        .catch(err => {
          console.log("err", err);
        });
    }
  }, []);

  const submitFormHandler = (data, action) => {
    setTimeout(() => {
      props.history.push("/service-location");
    }, 2000);
  };

  return (
    <UserWrapper {...props}>
      <div className="pos-relative">
        <PageTitle
          props={props}
          title="sidebar.service_location"
          className="plr-15"
          breadCrumb={[
            {
              name: "sidebar.dashboard",
              url: "/dashboard"
            },
            {
              name: "sidebar.service_location",
              url: "/service-location"
            },
            {
              name: hasParam ? "action.edit" : "action.add"
            }
          ]}
        />
        <div
          className="back-icon fs-15 demi-bold-text cursor-pointer"
          onClick={() => props.history.push("/service-location")}
        >
          <i className="fas fa-step-backward"></i> Back
        </div>
      </div>

      <div className="plr-15">
        <div className="roe-card-style mtb-15">
          <div className="roe-card-header module-header">
            <div className="flex-1 fs-16 demi-bold-text">
              <span className="hash"># </span> {hasParam ? "Edit" : "Add"}{" "}
              Service Location
            </div>
          </div>
          <div className="roe-card-body">
            <ServiceLocationForm
              onSubmit={submitFormHandler}
              editedData={editedData}
              action={hasParam ? "edit" : "add"}
            />
          </div>
        </div>
      </div>
    </UserWrapper>
  );
};

const mapStateToProps = state => {
  return {
    ...state.themeChanger
  };
};

export default connect(mapStateToProps, null)(ServiceLocationEdit);
